import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/themes/lara-light-cyan/theme.css";

import NotFoundPage from "./WebApp/Components/NotFoundPage";
import ErrorBoundary from "./WebApp/Components/ErrorBoundary";
import ErrorPageMain from "./WebApp/Components/ErrorPageMain";

import { AuthProvider } from "./WebApp/Authentication/AuthContext";
import Login from "./WebApp/Pages/Login/Login";
import ForgotPassword from "./WebApp/Pages/ForgotPassword/ForgotPassword";
import Signup from "./WebApp/Pages/Signup/Signup";
import Plans from "./WebApp/Pages/Plans/Plans";
import DashBoard from "./WebApp/Pages/DashBoard/DashBoard";
import QuickAccessFolders from "./WebApp/Pages/DashBoard/QuickAccessFolders";
import MyProfile from "./WebApp/Pages/Profile/MyProfile";

//layouts
import MainLayout from "./WebApp/Layout/MainLayout";
import PrivateRoute from "./WebApp/Authentication/PrivateRoute";
import ProjectLayout from "./WebApp/Pages/ProjectLayout/ProjectLayout";

//Contact pages
import Contact from "./WebApp/Pages/Contact/Contact";
import AddEmployeeContact from "./WebApp/Pages/Contact/Employee/AddEmployeeContact";
import ViewEmployeeContact from "./WebApp/Pages/Contact/Employee/ViewEmployeeContact";
import AddProfessionalContact from "./WebApp/Pages/Contact/Professional/AddProfessionalContact";
import ViewSelfEmployeeContact from "./WebApp/Pages/Contact/Professional/ViewSelfEmployeeContact";
import ViewCompanyEmployeeContact from "./WebApp/Pages/Contact/Professional/ViewCompanyEmployeeContact";
import AddClientContact from "./WebApp/Pages/Contact/Client/AddClientContact";
import ViewCommercialClientContact from "./WebApp/Pages/Contact/Client/ViewCommercialClientContact";
import ViewDomesticClientContact from "./WebApp/Pages/Contact/Client/ViewDomesticClientContact";
//

// Project pages
import ProjectComponent from "./WebApp/Pages/Project/Project";
import ProjectDetail from "./WebApp/Pages/Project/ProjectDetail/ProjectDetail";
import ServiceProjects from "./WebApp/Pages/Project/ServiceProjects";

// Custom services
import Drawing from "./WebApp/Pages/Project/CustomService/Drawing/Drawing";
import DrawingDefaultFolder from "./WebApp/Pages/Project/CustomService/Drawing/DrawingDefaultFolder";
import SubFolder from "./WebApp/Pages/Project/CustomService/Drawing/SubFolder";
import Document from "./WebApp/Pages/Project/CustomService/Document/Document";

// Default services
import Tender from "./WebApp/Pages/Project/DefaultService/PreCommencement/Tender/Tender";
import TenderDocument from "./WebApp/Pages/Project/DefaultService/PreCommencement/Tender/TenderDocument/TenderDocument";
import SOW from "./WebApp/Pages/Project/DefaultService/PreCommencement/Tender/SOW/SOW";
import CustomSOW from "./WebApp/Pages/Project/DefaultService/PreCommencement/Tender/SOW/CustomSOW/CustomSOW";
import TemplateSOW from "./WebApp/Pages/Project/DefaultService/PreCommencement/Tender/SOW/TemplateSOW/TemplateSOW";
import ViewSOW from "./WebApp/Pages/Project/DefaultService/PreCommencement/Tender/SOW/CustomSOW/ViewSOW";
import TenderList from "./WebApp/Pages/Project/DefaultService/PreCommencement/Tender/TenderList/TenderList";
import TenderComparisonView from "./WebApp/Pages/Project/DefaultService/PreCommencement/Tender/TenderList/TenderComparisonView";

import DischargeCondition from "./WebApp/Pages/Project/DefaultService/PreCommencement/DischargeCondition/DischargeCondition";
import DischargeConditionDetail from "./WebApp/Pages/Project/DefaultService/PreCommencement/DischargeCondition/DischargeConditionDetail";
import Valuation from "./WebApp/Pages/Project/DefaultService/Onsite/Valuation/Valuation";
import PaymentTracker from "./WebApp/Pages/Project/DefaultService/Onsite/PaymentTracker/PaymentTracker";
import PaymentTrackerService from "./WebApp/Pages/Project/DefaultService/Onsite/PaymentTracker/PaymentTrackerService";
import PaymentCertificate from "./WebApp/Pages/Project/DefaultService/Onsite/PaymentCertificate/PaymentCertificate";

import Programme from "./WebApp/Pages/Project/DefaultService/Onsite/Programme/Programme";
import ProgrammeTask from "./WebApp/Pages/Project/DefaultService/Onsite/Programme/ProgrammeTask/ProgrammeTask";

import ValuationEdit from "./WebApp/Pages/Project/DefaultService/Onsite/ValuationEdit/ValuationEdit";
import CompletionCertificate from "./WebApp/Pages/Project/DefaultService/Onsite/CompletionCertificate/CompletionCertificate";
import CashFlow from "./WebApp/Pages/Project/DefaultService/General/CashFlow/CashFlow";
import Refinancing from "./WebApp/Pages/Project/DefaultService/General/Refinancing/Refinancing";

/* Development appraisal */
import DevelopmentAppraisal from "./WebApp/Pages/Project/DefaultService/General/DevelopmentAppraisal/DevelopmentAppraisal";
import GDVCostDetail from "./WebApp/Pages/Project/DefaultService/General/DevelopmentAppraisal/GDVCost/GDVCost";

/* Site visit */
import SiteVisit from "./WebApp/Pages/Project/DefaultService/Onsite/SiteVisit/SiteVisit";
import SiteVisitDetail from "./WebApp/Pages/Project/DefaultService/Onsite/SiteVisit/SiteVisitDetail";
import SiteVisitReport from "./WebApp/Pages/Project/DefaultService/Onsite/SiteVisit/SiteVisitReport";

/* Site visit */
import SiteVisitReportService from "./WebApp/Pages/Project/DefaultService/Onsite/SiteVisitReport/SiteVisitReport";
import SiteVisitReportDetail from "./WebApp/Pages/Project/DefaultService/Onsite/SiteVisitReport/SiteVisitReportDetail";
import SiteVisitReportPreview from "./WebApp/Pages/Project/DefaultService/Onsite/SiteVisitReport/SiteVisitReportPreview";

/* Site visit tracker */
import SiteVisitTracker from "./WebApp/Pages/Project/DefaultService/Onsite/SiteVisitTracker/SiteVisitTracker";
import SiteVisitTrackerDetail from "./WebApp/Pages/Project/DefaultService/Onsite/SiteVisitTracker/SiteVisitTrackerDetail";
import SiteVisitTrackerReport from "./WebApp/Pages/Project/DefaultService/Onsite/SiteVisitTracker/SiteVisitTrackerReport";

/* Plan check */
import PlanCheck from "./WebApp/Pages/Project/DefaultService/PreCommencement/PlanCheck/PlanCheck";
import PlanCheckList from "./WebApp/Pages/Project/DefaultService/PreCommencement/PlanCheck/PlanCheckList";
import PlanCheckDetail from "./WebApp/Pages/Project/DefaultService/PreCommencement/PlanCheck/PlanCheckDetail";
import PlanCheckBasic from "./WebApp/Pages/Project/DefaultService/PreCommencement/PlanCheck/PlanCheckBasic";
import PlanCheckReport from "./WebApp/Pages/Project/DefaultService/PreCommencement/PlanCheck/PlanCheckReport";

/* Plan check tracker */
import PlanCheckTracker from "./WebApp/Pages/Project/DefaultService/PreCommencement/PlanCheckTracker/PlanCheckTracker";
import PlanCheckTrackerDetail from "./WebApp/Pages/Project/DefaultService/PreCommencement/PlanCheckTracker/PlanCheckTrackerDetail";
import PlanCheckTrackerBasic from "./WebApp/Pages/Project/DefaultService/PreCommencement/PlanCheckTracker/PlanCheckTrackerBasic";
import PlanCheckTrackerList from "./WebApp/Pages/Project/DefaultService/PreCommencement/PlanCheckTracker/PlanCheckTrackerList";
import PlanCheckTrackerReport from "./WebApp/Pages/Project/DefaultService/PreCommencement/PlanCheckTracker/PlanCheckTrackerReport";

/* Building control services */
import DutyHolderDetails from "./WebApp/Pages/Project/DefaultService/PreCommencement/DutyHolderDetails/New/DutyHolderDetails";
import InitialNotice from "./WebApp/Pages/Project/DefaultService/PreCommencement/InitialNotice/InitialNotice";
import CommencementNotification from "./WebApp/Pages/Project/DefaultService/PreCommencement/CommencementNotification/CommencementNotification";
import ComplianceDeclaration from "./WebApp/Pages/Project/DefaultService/General/ComplianceDeclaration/ComplianceDeclaration";

import BuildingControlProjects from "./WebApp/Pages/BuildingControl/BuildingControlProjects";
import BuildingControlQuotation from "./WebApp/Pages/BuildingControl/BuildingControlQuotation";
import BuildingControlPermission from "./WebApp/Pages/BuildingControl/BuildingControlPermission";

/* Site inspection booking */
import SiteInspectionBooking from "./WebApp/Pages/Project/DefaultService/Onsite/SiteInspectionBooking/SiteInspectionBooking";

/* Tools */
import Tools from "./WebApp/Pages/Haytrader/Tools/Tools";

/* Attendance */
import Attendance from "./WebApp/Pages/Haytrader/Attendance/New/Attendance";
// import Attendance from "./WebApp/Pages/Haytrader/Attendance/Attendance";
import SiteEmployees from "./WebApp/Pages/Haytrader/Attendance/New/SiteEmployees";

/* Materials */
import MaterialsProjects from "./WebApp/Pages/Haytrader/Materials/MaterialsProjects";
import MaterialOption from "./WebApp/Pages/Haytrader/Materials/MaterialOption";
import Materials from "./WebApp/Pages/Haytrader/Materials/Materials";
import MaterialItems from "./WebApp/Pages/Haytrader/Materials/MaterialItems";
import MaterialTemplate from "./WebApp/Pages/Haytrader/Materials/MaterialTemplate";

/* Purchase spending */
import ProjectSpending from "./WebApp/Pages/Haytrader/ProjectSpending/ProjectSpending";
import ProjectSpendingProjects from "./WebApp/Pages/Haytrader/ProjectSpending/ProjectSpendingProjects";
import ProjectSpendingQuotation from "./WebApp/Pages/Haytrader/ProjectSpending/ProjectSpendingQuotation";

/* Client account */
import ClientAccount from "./WebApp/Pages/Haytrader/ClientAccount/ClientAccount";
import ClientAccountProjects from "./WebApp/Pages/Haytrader/ClientAccount/ClientAccountProjects";

/* Shopping list */
import ShoppingList from "./WebApp/Pages/Haytrader/ShoppingList/ShoppingList";

/* Task */
import Task from "./WebApp/Pages/Task/Task";

/* Reminder */
import Reminder from "./WebApp/Pages/Reminder/Reminder";

/* To Do */
import ToDo from "./WebApp/Pages/ToDo/ToDo";

/* Faq */
import AppFaq from "./WebApp/Pages/Faq/AppFaq";

/* Contact Us */
import AppContactUs from "./WebApp/Pages/ContactUs/AppContactUs";

/* Payment */
import Payment from "./WebApp/Pages/Payment/Payment";

/* My subscription */
import MySubscription from "./WebApp/Pages/MySubscription/MySubscription";

/* Settings */
import Settings from "./WebApp/Pages/Settings/Settings";

/* Quotation */
import Quotation from "./WebApp/Pages/Quotation/Quotation";
import QuotationDetail from "./WebApp/Pages/Quotation/QuotationDetail";
import QuotationList from "./WebApp/Pages/Quotation/QuotationList";
import QuotationReport from "./WebApp/Pages/Quotation/QuotationReport";
import QuotationTemplate from "./WebApp/Pages/Quotation/QuotationTemplate";

/* Finishing schedule */
import FinishingSchedule from "./WebApp/Pages/FinishingSchedule/FinishingSchedule";
import FinishingScheduleProjects from "./WebApp/Pages/FinishingSchedule/FinishingScheduleProjects";
import FinishingScheduleDocument from "./WebApp/Pages/FinishingSchedule/FinishingScheduleDocument";
import FinishingScheduleReport from "./WebApp/Pages/FinishingSchedule/FinishingScheduleReport";

/* Project progress */
import ProjectProgress from "./WebApp/Pages/ProjectProgress/ProjectProgress";

/* Website */
import WebLayout from "./Website/Components/WebLayout";
import Home from "./Website/Pages/Home/Home";
import About from "./Website/Pages/About/About";
import UseCase from "./Website/Pages/UseCase/UseCase";
import ContactUs from "./Website/Pages/ContactUs/ContactUs";
import Faq from "./Website/Pages/Faq/Faq";
import TermsOfService from "./Website/Pages/TermsOfService/TermsOfService";
import PrivacyPolicy from "./Website/Pages/PrivacyPolicy/PrivacyPolicy";
import CookiesPolicy from "./Website/Pages/CookiesPolicy/CookiesPolicy";
import Careers from "./Website/Pages/Careers/Careers";
import Blogs from "./Website/Pages/Blogs/Blogs";
import MoreInfo from "./Website/Pages/MoreInfo/MoreInfo";
import UserGuidance from "./Website/Pages/UserGuidance/UserGuidance";
import ApplicationCheckList from "./WebApp/Pages/Project/DefaultService/PreCommencement/ApplicationCheckList/ApplicationCheckList";
import CommencementChecklist from "./WebApp/Pages/Project/DefaultService/Onsite/CommencementCheckList/CommencementChecklist";
import DrawingCheckList from "./WebApp/Pages/Project/DefaultService/Onsite/DrawingCheckList/DrawingCheckList";

function App() {
  const value = {
    ripple: true,
  };

  return (
    <React.Fragment>
      <PrimeReactProvider value={value}>
        <BrowserRouter>
          <AuthProvider>
            <ErrorBoundary>
              <Routes>
                <Route element={<PrivateRoute />}>
                  <Route path="/" element={<MainLayout />}>
                    {/* <Route index element={<DashBoard />} /> */}
                    <Route path="dash-board" element={<DashBoard />} />
                    <Route
                      path="quick-access"
                      element={<QuickAccessFolders />}
                    />
                    <Route path="my-profile" element={<MyProfile />} />

                    {/* Contact Routes */}
                    <Route
                      path="contact"
                      element={<Contact />}
                    />

                    <Route
                      path="contact/employee/add"
                      element={<AddEmployeeContact />}
                    />

                    <Route
                      path="contact/employee/view"
                      element={<ViewEmployeeContact />}
                    />

                    <Route
                      path="contact/professional/add"
                      element={<AddProfessionalContact />}
                    />

                    <Route
                      path="contact/professional/self-employee/view"
                      element={<ViewSelfEmployeeContact />}
                    />
                    <Route
                      path="contact/professional/company-employee/view"
                      element={<ViewCompanyEmployeeContact />}
                    />
                    <Route
                      path="contact/client/add"
                      element={<AddClientContact />}
                    />
                    <Route
                      path="contact/client/commercial-client/view"
                      element={<ViewCommercialClientContact />}
                    />
                    <Route
                      path="contact/client/domestic-client/view"
                      element={<ViewDomesticClientContact />}
                    />

                    {/* Project Routes */}
                    <Route path="project" element={<ProjectComponent />} />
                    <Route path="service/projects" element={<ServiceProjects />} />
                    <Route path="project/detail" element={<ProjectDetail />} />

                    {/* For Custom Service */}
                    <Route
                      path="project/detail/custom-service/document-drawing"
                      element={<Drawing />}
                    />

                    <Route
                      path="project/detail/custom-service/drawing/sub-folder"
                      element={<SubFolder />}
                    />

                    <Route
                      path="project/detail/custom-service/document"
                      element={<Document />}
                    />

                    {/* Default service */}
                    {/* Tender */}
                    <Route
                      path="project/detail/default-service/pre-commencement/tender"
                      element={<Tender />}
                    />
                    <Route
                      path="project/detail/default-service/pre-commencement/tender/tender-document"
                      element={<TenderDocument />}
                    />
                    <Route
                      path="project/detail/default-service/pre-commencement/tender/sow"
                      element={<SOW />}
                    />

                    {/* Discharge Condition */}
                    <Route
                      path="project/detail/default-service/pre-commencement/discharge-condition"
                      element={<DischargeCondition />}
                    />
                    <Route
                      path="project/detail/default-service/pre-commencement/discharge-condition/detail"
                      element={<DischargeConditionDetail />}
                    />

                    {/* Valuation */}
                    <Route
                      path="project/detail/default-service/onsite/valuation"
                      element={<Valuation />}
                    />

                    {/* Payment Tracker */}
                    <Route
                      path="project/detail/default-service/onsite/payment-tracker"
                      element={<PaymentTracker />}
                    />
                    <Route
                      path="project/detail/default-service/onsite/payment-tracker/service"
                      element={<PaymentTrackerService />}
                    />

                    {/* Payment Certificate */}
                    <Route
                      path="project/detail/default-service/onsite/payment-certificate"
                      element={<PaymentCertificate />}
                    />

                    {/* Program */}
                    <Route
                      path="project/detail/default-service/onsite/programe"
                      element={<Programme />}
                    />
                    <Route
                      path="project/detail/default-service/onsite/programe/task"
                      element={<ProgrammeTask />}
                    />

                    {/* Completion Certificate */}
                    <Route path="project/detail/default-service/onsite/completion-certificate" element={<CompletionCertificate />} />

                    {/* Tools */}
                    <Route path="tools" element={<Tools />} />

                    <Route path="project/tools" element={<Tools />} />

                    {/* Attendance */}
                    <Route path="attendance" element={<Attendance />} />
                    <Route path="attendance/site-employees" element={<SiteEmployees />} />

                    <Route path="project/attendance" element={<Attendance />} />
                    <Route path="project/attendance/site-employees" element={<SiteEmployees />} />

                    {/* Materials */}
                    <Route path="materials" element={<Materials />} />
                    <Route path="materials/projects" element={<MaterialsProjects />} />
                    <Route path="materials/option" element={<MaterialOption />} />
                    <Route path="materials/items" element={<MaterialItems />} />
                    <Route path="materials/template" element={<MaterialTemplate />} />

                    <Route path="project/materials" element={<Materials />} />
                    <Route path="project/materials/option" element={<MaterialOption />} />
                    <Route path="project/materials/items" element={<MaterialItems />} />
                    <Route path="project/materials/template" element={<MaterialTemplate />} />

                    {/* Project spending */}
                    <Route path="project-spending" element={<ProjectSpending />} />
                    <Route path="project-spending/projects" element={<ProjectSpendingProjects />} />
                    <Route path="project-spending/quotation" element={<ProjectSpendingQuotation />} />

                    <Route path="project/project-spending" element={<ProjectSpending />} />
                    <Route path="project/project-spending/quotation" element={<ProjectSpendingQuotation />} />

                    {/* Client account */}
                    <Route path="client-account" element={<ClientAccount />} />
                    <Route path="client-account/projects" element={<ClientAccountProjects />} />
                    <Route path="project/client-account" element={<ClientAccount />} />

                    {/* Shopping list */}
                    <Route path="shopping-list" element={<ShoppingList />} />

                    {/* Invoice */}
                    <Route path="invoice" element={<Payment />} />

                    {/* Refinancing */}
                    <Route
                      path="project/detail/default-service/general/refinancing"
                      element={<Refinancing />}
                    />

                    {/* CashFlow */}
                    <Route
                      path="project/detail/default-service/general/cash-flow"
                      element={<CashFlow />}
                    />

                    {/* Development Appraisal */}
                    <Route
                      path="project/detail/default-service/general/development-appraisal"
                      element={<DevelopmentAppraisal />}
                    />
                    <Route
                      path="project/detail/default-service/general/development-appraisal/gdv-cost"
                      element={<GDVCostDetail />}
                    />

                    {/* Duty Holder Details */}
                    <Route
                      path="project/detail/default-service/pre-commencement/dutyholder-details"
                      element={<DutyHolderDetails />}
                    />

                    {/* Initial Notice */}
                    <Route
                      path="project/detail/default-service/pre-commencement/initial-notice"
                      element={<InitialNotice />}
                    />

                    {/* Commencement Notification */}
                    <Route
                      path="project/detail/default-service/pre-commencement/commencement-notification"
                      element={<CommencementNotification />}
                    />

                    {/* Compliance Declaration */}
                    <Route
                      path="project/detail/default-service/general/compliance-declaration"
                      element={<ComplianceDeclaration />}
                    />

                    {/* Building Control Projects */}
                    <Route
                      path="building-control/projects"
                      element={<BuildingControlProjects />}
                    />

                    {/* Building Control Quotation */}
                    <Route
                      path="building-control/quotation"
                      element={<BuildingControlQuotation />}
                    />

                    {/* Building Control Permission */}
                    <Route
                      path="building-control/permission"
                      element={<BuildingControlPermission />}
                    />



                    {/* application checklist */}
                    <Route
                      path="project/detail/default-service/pre-commencement/application-checklist"
                      element={<ApplicationCheckList />}
                    />


                     {/* commencement checklist */}
                    <Route
                      path="project/detail/default-service/onsite/commencement-checklist"
                      element={<CommencementChecklist />}
                    />


                    
                     {/* commencement checklist */}
                    <Route
                      path="project/detail/default-service/onsite/detail-drawing-checklist"
                      element={<DrawingCheckList />}
                    /> 




                    {/* Task Routes */}
                    <Route path="task" element={<Task />} />

                    {/* Reminder Routes */}
                    <Route path="reminder" element={<Reminder />} />

                    {/* To Do Routes */}
                    <Route path="to-do" element={<ToDo />} />

                    {/* My subscription */}
                    <Route
                      path="my-subscription"
                      element={<MySubscription />}
                    />

                    {/* Faq Route */}
                    <Route path="app-faq" element={<AppFaq />} />

                    {/* Contact Us Route */}
                    <Route path="app-contact-us" element={<AppContactUs />} />

                    {/* Settings */}
                    <Route path="settings" element={<Settings />} />


                    {/* Plan check */}
                    <Route
                      path="project/detail/default-service/pre-commencement/plan-check"
                      element={<PlanCheck />}
                    />
                    <Route
                      path="project/detail/default-service/pre-commencement/plan-check/list"
                      element={<PlanCheckList />}
                    />

                    {/* Plan check tracker */}
                    <Route
                      path="project/detail/default-service/pre-commencement/plan-check-tracker"
                      element={<PlanCheckTracker />}
                    />
                    <Route
                      path="project/detail/default-service/pre-commencement/plan-check-tracker/list"
                      element={<PlanCheckTrackerList />}
                    />

                    {/* Quotation */}
                    <Route path="quotation" element={<Quotation />} />
                    <Route path="quotation/list" element={<QuotationList />} />

                    {/* Finishing schdule */}
                    <Route path="finishing-shedule" element={<FinishingSchedule />} />
                    <Route path="finishing-shedule/document" element={<FinishingScheduleDocument />} />
                    <Route path="finishing-shedule/projects" element={<FinishingScheduleProjects />} />

                    <Route path="project/finishing-shedule" element={<FinishingSchedule />} />
                    <Route path="project/finishing-shedule/document" element={<FinishingScheduleDocument />} />

                    {/* Site inspection booking*/}
                    <Route
                      path="/project/detail/default-service/onsite/site-inspection-booking"
                      element={<SiteInspectionBooking />}
                    />

                    {/* Project progress */}
                    <Route
                      path="/project-progress"
                      element={<ProjectProgress />}
                    />
                  </Route>

                  <Route element={<ProjectLayout />}>
                    <Route
                      path="project/detail/custom-service/drawing"
                      element={<DrawingDefaultFolder />}
                    />

                    <Route
                      path="project/detail/custom-service/drawing/default-folder"
                      element={<DrawingDefaultFolder />}
                    />

                    {/* Tender */}
                    <Route
                      path="/project/detail/default-service/pre-commencement/tender/sow/customize"
                      element={<CustomSOW />}
                    />
                    <Route
                      path="/project/detail/default-service/pre-commencement/tender/sow/template"
                      element={<TemplateSOW />}
                    />
                    <Route
                      path="/project/detail/default-service/pre-commencement/tender/sow/customize/view"
                      element={<ViewSOW />}
                    />

                    <Route
                      path="/project/detail/default-service/pre-commencement/tender/tender-list"
                      element={<TenderList />}
                    />
                    <Route
                      path="/project/detail/default-service/pre-commencement/tender/tender-list/compare"
                      element={<TenderComparisonView />}
                    />

                    {/* Valuation Edit */}
                    <Route
                      path="/project/detail/default-service/onsite/valuation-edit"
                      element={<ValuationEdit />}
                    />

                    {/* Plan check */}
                    <Route
                      path="/project/detail/default-service/pre-commencement/plan-check/detail"
                      element={<PlanCheckDetail />}
                    />
                    <Route
                      path="/project/detail/default-service/pre-commencement/plan-check/basic"
                      element={<PlanCheckBasic />}
                    />
                    {/* <Route
                      path="/project/detail/default-service/pre-commencement/plan-check/response"
                      element={<PlanCheckResponse />}
                    /> */}
                    <Route
                      path="/project/detail/default-service/pre-commencement/plan-check/report"
                      element={<PlanCheckReport />}
                    />
                    {/*  */}

                    {/* Plan check tracker */}
                    <Route
                      path="/project/detail/default-service/pre-commencement/plan-check-tracker/detail"
                      element={<PlanCheckTrackerDetail />}
                    />
                    <Route
                      path="/project/detail/default-service/pre-commencement/plan-check-tracker/basic"
                      element={<PlanCheckTrackerBasic />}
                    />
                    {/* <Route
                      path="/project/detail/default-service/pre-commencement/plan-check-tracker/response"
                      element={<PlanCheckTrackerResponse />}
                    /> */}
                    <Route
                      path="/project/detail/default-service/pre-commencement/plan-check-tracker/report"
                      element={<PlanCheckTrackerReport />}
                    />

                    {/* Site visit */}
                    <Route
                      path="/project/detail/default-service/onsite/site-visit"
                      element={<SiteVisit />}
                    />
                    <Route
                      path="/project/detail/default-service/onsite/site-visit/detail"
                      element={<SiteVisitDetail />}
                    />
                    <Route
                      path="/project/detail/default-service/onsite/site-visit/report"
                      element={<SiteVisitReport />}
                    />

                    {/* Site visit report*/}
                    <Route
                      path="/project/detail/default-service/onsite/site-visit-report"
                      element={<SiteVisitReportService />}
                    />

                    <Route
                      path="/project/detail/default-service/onsite/site-visit-report/detail"
                      element={<SiteVisitReportDetail />}
                    />

                    <Route
                      path="/project/detail/default-service/onsite/site-visit-report/preview"
                      element={<SiteVisitReportPreview />}
                    />

                    {/* Site visit tracker*/}
                    <Route
                      path="/project/detail/default-service/onsite/site-visit-tracker"
                      element={<SiteVisitTracker />}
                    />

                    <Route
                      path="/project/detail/default-service/onsite/site-visit-tracker/detail"
                      element={<SiteVisitTrackerDetail />}
                    />

                    <Route
                      path="/project/detail/default-service/onsite/site-visit-tracker/report"
                      element={<SiteVisitTrackerReport />}
                    />

                    {/* Quotation */}
                    <Route path="/quotation/detail" element={<QuotationDetail />} />
                    <Route path="/quotation/report" element={<QuotationReport />} />
                    <Route path="/quotation/template" element={<QuotationTemplate />} />

                    {/* Finishing shedule */}
                    <Route path="/finishing-shedule/report" element={<FinishingScheduleReport />} />
                  </Route>
                </Route>

                {/* Web routes */}
                <Route path="/" element={<WebLayout />}>
                  <Route index element={<Home />} />
                  <Route path="about-us" element={<About />} />
                  <Route path="use-case" element={<UseCase />} />
                  <Route path="pricing" element={<Plans />} />
                  <Route path="contact-us" element={<ContactUs />} />
                  <Route path="terms-of-service" element={<TermsOfService />} />
                  <Route path="privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="cookies-policy" element={<CookiesPolicy />} />
                  <Route path="faq" element={<Faq />} />
                  {/* <Route path="careers" element={<Careers />} /> */}
                  {/* <Route path="blogs" element={<Blogs />} /> */}
                  {/* <Route path='more-info' element={<MoreInfo />} /> */}
                  {/* <Route path="guide" element={<UserGuidance />} /> */}
                </Route>

                <Route path="/auth" element={<WebLayout />}>
                  <Route path="login" element={<Login />} />
                  <Route path="forgot-password" element={<ForgotPassword />} />
                  <Route path="signup" element={<Signup />} />
                </Route>

                <Route path="*" element={<NotFoundPage />} />
                <Route path="/error" element={<ErrorPageMain />} />
              </Routes>
            </ErrorBoundary>
          </AuthProvider>
        </BrowserRouter>
      </PrimeReactProvider>
    </React.Fragment>
  );
}

export default App;
